// Pre-Visit Planning Module (Módulo D — BillingV2)
// Huddle sheet por cita: HCCs sospechosos, care gaps, meds y labs antes de la visita.

import PrevisitPlanningPage from "./pages/PrevisitPlanningPage";

// Export routes for AppRouter
export const previsitPlanningRoutes = [
  {
    path: "/previsit-planning",
    element: <PrevisitPlanningPage />,
  },
];

// Export components for external use
export { default as PrevisitPlanningPage } from "./pages/PrevisitPlanningPage";

// Export utilities
export * from "./common/constants";
